const _ = require('underscore');
const en = require('./languages/en/en.js');
const es = require('./languages/es/es.js');
const cmn = require('./languages/zh/cmn.js');
const hk = require('./languages/zh/hk.js');
const vi = require('./languages/vi/vi.js');
const ko = require('./languages/ko/ko.js');
const ar = require('./languages/ar/ar.js');
const ht = require('./languages/ht/ht.js');

let defaultLanguage = 'en';
const languageList = [en, es, cmn, hk, vi, ko, ar, ht];

const languageMap = languageList.reduce(
	(acc, lang) =>
		_.assign(acc, {
			[lang.languageCode]: lang
		}),
	{}
);

const getLanguageSetRaw = languageCode => {
	let map = languageMap[languageCode];
	if (map) {
		map = _.assign({}, map);
	}
	return map;
};

const getLanguageSet = languageCode => {
	let languageKeys = getLanguageSetRaw(languageCode) || {};
	let defaultKeys = languageMap[this.defaultLanguage] || {};

	return _.assign({}, defaultKeys, languageKeys);
};

const getLanguageList = () => languageList.map(lang => _.assign({}, lang));

const i18n = {
	defaultLanguage,
	getLanguageSet,
	getLanguageSetRaw,
	getLanguageList
};

module.exports = i18n;
